import React from "react";
import { FloatingWhatsApp } from 'react-floating-whatsapp'
// reactstrap components
// core components
import ColorNavbar from "components/Navbars/InfoNavbar.js";
import SectionHeader from "./sections-sections/SectionHeader.js";
import Feature2 from "./sections-sections/Feature2.js"
import FooterBlack from "components/Footers/FooterBlack.js";
import Buttons from "components/Headers/Buttons.js"
// sections for this page
import SectionBlog from "./sections-sections/SectionBlog.js";
import SectionContactUs from "./sections-sections/SectionContactUs.js";
function Presentation() {
  
  document.documentElement.classList.remove("nav-open");
  // function that is being called on scroll of the page
  const checkScroll = () => {
    // it takes all the elements that have the .add-animation class on them
    const componentPosition = document.getElementsByClassName("add-animation");
    const scrollPosition = window.pageYOffset;
    for (var i = 0; i < componentPosition.length; i++) {
      var rec =
        componentPosition[i].getBoundingClientRect().top + window.scrollY + 100;
      // when the element with the .add-animation is in the scroll view,
      // the .animated class gets added to it, so it creates a nice fade in animation
      if (scrollPosition + window.innerHeight >= rec) {
        componentPosition[i].classList.add("animated");
        // when the element with the .add-animation is not in the scroll view,
        // the .animated class gets removed from it, so it creates a nice fade out animation
      } else if (scrollPosition + window.innerHeight * 0.8 < rec) {
        componentPosition[i].classList.remove("animated");
      }
    }
  };

  React.useEffect(() => {
    document.body.classList.add("presentation-page");
    window.addEventListener("scroll", checkScroll);
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("presentation-page");
      window.removeEventListener("scroll", checkScroll);
    };
  });
  return (
    <>
    <FloatingWhatsApp phoneNumber="+573006572717" accountName="BTCartagena" />
      <ColorNavbar />
      <br/>
   
    <Buttons/>
    <div style={{height:"3px", backgroundColor: "gold"}} />

      <SectionHeader />
    <SectionBlog />
    <Feature2/>
    <SectionContactUs/>
      <FooterBlack />
    </>
  );
}

export default Presentation;
